import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { ST_INQUIRIES_PROOF_OF_STUDY_CREATE, ST_INQUIRIES_PROOF_OF_STUDY_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const stInquiriesProofOfStudyCreate = createAsyncThunk(
  ST_INQUIRIES_PROOF_OF_STUDY_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stInquiriesProofOfStudyCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stInquiriesProofOfStudyList = createAsyncThunk(
  ST_INQUIRIES_PROOF_OF_STUDY_LIST,
  async (
    params: PayloadCreatorParams<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.stInquiriesProofOfStudyList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stInquiriesProofOfStudyListClear = createAction(`${ST_INQUIRIES_PROOF_OF_STUDY_LIST}/clear`)
